
































































import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import Auth from './Auth.vue'
import { user } from '../fire'
import * as Interface from '../../functions/interfaces'

interface Result {
    status: string
    transactionId: number
}


export default Vue.extend({
    components: { Auth },


    mounted() {
        // If the page was called by Simple
        if (this.$route.query.r) this.finalise(this.$route.query.r as string)
    },


    props: ['projectId', 'currency'],


    data() {
        return {
            user: user,
            tiers: [3000, 5000, 10000],
            pledge: 0,
            customPledge: undefined as number | undefined,
            loading: false
        }
    },


    computed: {
        ht() {
            if (this.loading) return this.$t('loading')
            else return this.$t('pledge')
        },
        buttonDisabled(): boolean {
            const validated = user.first_name != '' && user.last_name != '' && user.email != '' && user.address?.country != '' 
                                && user.address?.zip != '' && user.address?.city != '' && user.address?.line != ''
            return !this.$refs.auth?.agreed || this.loading || user.id == '' ||  !validated || (this.pledge < 1000 && (this.customPledge ?? 0) < 1000)
        },
    },


    methods: {
        changePledge(value: number) {
            this.customPledge = undefined
            this.pledge = value
        },


        makePledge: async function() {
            
            // Validate
            // @ts-ignore
            const validation = this.$refs.auth.validate()
            if (validation) { alert(validation); return }
            this.loading = true


            // Save the user details
            // @ts-ignore
            await this.$refs.auth.save()


            // Pledge
            const pledge = Math.max(this.pledge, this.customPledge || 0)
            const endpoint = firebase.functions().httpsCallable('pledge')
            const payload = {projectId: this.projectId, pledge: pledge, alias: this.$route.params.alias}
            
            try {

                // Load
                const response = await endpoint(payload)
                const result = response?.data as unknown as Interface.PledgeResult


                // Error handling
                if (result.paymentUrl == undefined) {
                    alert(this.$t('payment_service_error'))
                    return
                }


                // Open new tab for SimplePay
                window.location.href = result.paymentUrl

            } catch(e) {
                alert(e)
            } finally {
                this.loading = false
            }
        },


        finalise: async function(result: string) {

            // Transmit result
            this.loading = true
            this.$emit('pledge', {status: 'STARTED'})


            // Listen for the pledge status
            const response = await firebase.functions().httpsCallable('end')(result)
            const pledgeId = response.data.pledgeId
            firebase.firestore().collection('pledges').doc(pledgeId).onSnapshot((snap) => {
                if (!snap.exists) return

                const pledge = snap.data() as unknown as Interface.Pledge
                this.$emit('pledge', pledge)

                if (pledge.status != 'SUCCESS') // SUCCESS IS JUST AN INTERMEDIATE STEP
                    this.loading = false
            })
        }
    }
})
